import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EModule, FallbackButtonLocale, FederatedModule, IButtonLocaleProps } from '@lumahealthhq/ui-common';
import { get } from 'lodash';

import { changeLocale } from '@lib/actions';
import { Locale } from '@lib/providers/LanguageProvider/LanguageProvider';
import { patientsResource } from '@lib/resources';
import { selectCurrentUser } from '@lib/selectors';

export interface LanguageSelectorProps {}

const LanguageSelector: React.FC<LanguageSelectorProps> = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);

  const handleChange = useCallback(
    (locale: Locale) => {
      dispatch(changeLocale(locale));
      const patientId = get(currentUser, 'id');
      if (patientId) {
        dispatch(
          patientsResource.request({
            method: 'put',
            url: `/patients/${patientId}/language`,
            data: {
              // Model accepts language only, not language-country
              language: locale.split('-')[0],
            },
            meta: {
              ignoreErrors: true,
            },
          }),
        );
      }
    },
    [dispatch, currentUser],
  );

  return (
    <FederatedModule<IButtonLocaleProps>
      module={EModule.ButtonLocale}
      fallback={<FallbackButtonLocale />}
      props={{
        onChange: (locale) => handleChange((locale as unknown) as Locale),
      }}
    />
  );
};

export default LanguageSelector;
